'use client';

import { Box } from '@mui/material';
import { Divider, Skeleton } from '@nxt-costco-com/forge-components';

export function FilterLoadingView() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
            }}
        >
            {[...Array(3).keys()].map((_, index) => {
                return (
                    <Box
                        key={`facet_loading_${index}`}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 4,
                        }}
                    >
                        <Divider />
                        {/* @ts-expect-error TODO: export this or let text as variant */}
                        <Skeleton variant="textHeader" />
                        {/* @ts-expect-error TODO: export this or let text as variant */}
                        <Skeleton variant="textBody" />
                        {/* @ts-expect-error TODO: export this or let text as variant */}
                        <Skeleton variant="textBody" />
                        {/* @ts-expect-error TODO: export this or let text as variant */}
                        <Skeleton variant="textBody" />
                    </Box>
                );
            })}
        </Box>
    );
}
